
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/loesungen/iot-zustandsueberwachung/luftqualitaet",
      function () {
        return require("private-next-pages/[locale]/loesungen/iot-zustandsueberwachung/luftqualitaet.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/loesungen/iot-zustandsueberwachung/luftqualitaet"])
      });
    }
  